import React from 'react';
import CollapseCommon from 'components/common/Collapse/CollapseCommon';
import { FormInstance } from 'antd';
import UnitConversionList from '../UnitConversionList/UnitConversionList';
import { Unit as UnitModel } from 'models';
import { Unit } from 'types';
interface Props {
  form: FormInstance;
  isEdits: boolean;
  buttonName: string;
  isEdit: boolean;
  isInactive?: boolean;
  setProductUnits?: (units: Unit[]) => void;
  productUnits?: Unit[];
  units?: UnitModel[];
  isDetail?: boolean;
}

const ProductSpecificationSection: React.FC<Props> = ({
  form,
  isEdits = true,
  buttonName = '',
  isEdit,
  isInactive,
  setProductUnits,
  productUnits = [],
  units,
  isDetail = false,
}) => {
  return (
    <CollapseCommon collapseKey='5' title='Đơn vị & quy cách sản phẩm'>
      <UnitConversionList
        form={form}
        isEdit={isEdit}
        // isInactive={isInactive}
        isEdits={isEdits}
        buttonName={buttonName}
        productUnits={productUnits}
        units={units}
        isView={isInactive || !isEdits}
        setProductUnits={setProductUnits}
        isDetail={isDetail}
      />
      {/* </div> */}
    </CollapseCommon>
  );
};

export default ProductSpecificationSection;
